import React, { useState, useEffect } from 'react';
import { Stack, Text } from '@moda/om';
import { kebabCase } from 'case-anything';

import './Careers.scss';

type Location = {
  name: string;
};

type Department = {
  id: number;
  name: string;
  jobs: { id: number; title: string; url: string; absolute_url: string; location: Location }[];
};

export const Careers = () => {
  const [depArray, setDepArray] = useState<Department[]>([]);

  useEffect(() => {
    fetch('https://boards-api.greenhouse.io/v1/boards/modaoperandi/departments')
      .then(response => response.json())
      .then(data => {
        if (data.errors && data.errors[0]) {
          return data.errors[0].detail;
        }
        window.departmentsData = data.departments;
        setDepArray(
          data.departments.filter((department: Department) => {
            return department.jobs.length !== 0;
          })
        );
      });
  }, []);

  return (
    <div className="Careers">
      <Text className="Careers__section-title" treatment="h2" family="serif">
        Current Openings
      </Text>
      <div className="Careers__results">
        {depArray.map((department: Department) => (
          <Stack
            space={3}
            className={`Careers__department Careers__department--is-${kebabCase(department.name)}`}
            key={department.id}
          >
            <Text treatment="h4" family="serif" className="Careers__department-title">
              {department.name}
            </Text>
            {department.jobs.map(job => (
              <a
                className="Careers__link"
                href={job.absolute_url}
                key={job.id}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="Careers__job-info">
                  <Text
                    treatment="body1"
                    className={`Careers__job--title Careers__job--title-is-${kebabCase(job.title)}`}
                  >
                    {job.title}
                  </Text>
                  <Text
                    treatment="body1"
                    className={`Careers__job--location Careers__job--location-is-${kebabCase(
                      job.location.name
                    )}`}
                  >
                    {job.location.name}
                  </Text>
                </div>
              </a>
            ))}
          </Stack>
        ))}
      </div>
    </div>
  );
};
